// assets/making-steps.js
if (!customElements.get('ms-carousel')) {
  customElements.define('ms-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ms-track]');
      if (!this.track) return;

      this.slides = Array.from(this.track.children);
      this.dots   = this.querySelector('[data-ms-dots]');
      this.prev   = this.querySelector('[data-ms-prev]');
      this.next   = this.querySelector('[data-ms-next]');
      this.index  = 0;

      this.onNav    = this.onNav.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.measure  = this.measure.bind(this);

      this.prev?.addEventListener('click', this.onNav);
      this.next?.addEventListener('click', this.onNav);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      // Only observe size changes — no scroll math on every frame.
      this.ro = new ResizeObserver(this.measure);
      this.ro.observe(this.track);

      this.buildDots();
      this.measure();
    }

    disconnectedCallback() {
      this.ro?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
      cancelAnimationFrame(this.raf);
    }

    // Slider is live only when the track actually overflows (handles grid↔slider breakpoint switch).
    measure() {
      const active = this.track.scrollWidth - this.track.clientWidth > 4;
      this.toggleAttribute('data-active', active);
      if (active) this.sync();
    }

    buildDots() {
      if (!this.dots) return;
      const frag = document.createDocumentFragment();
      this.slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Go to slide ${i + 1}`);
        b.addEventListener('click', () => this.goTo(i));
        frag.appendChild(b);
      });
      this.dots.appendChild(frag);
    }

    onNav(e) {
      const dir = e.currentTarget.hasAttribute('data-ms-next') ? 1 : -1;
      this.goTo(this.index + dir);
    }

    goTo(i) {
      const target = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
      if (!target) return;
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    onScroll() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.sync());
    }

    sync() {
      const x = this.track.scrollLeft;
      const base = this.track.offsetLeft;
      let idx = 0, best = Infinity;
      for (let i = 0; i < this.slides.length; i++) {
        const d = Math.abs(this.slides[i].offsetLeft - base - x);
        if (d < best) { best = d; idx = i; }
      }
      this.index = idx;

      if (this.dots) {
        for (let i = 0; i < this.dots.children.length; i++) {
          this.dots.children[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
        }
      }
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (this.prev) this.prev.disabled = x <= 1;
      if (this.next) this.next.disabled = x >= max - 1;
    }
  });
}